import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2277638e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = { class: "header-menu__icon" }
const _hoisted_4 = { class: "header-pagename" }
const _hoisted_5 = { class: "header-info" }

import { ref, onMounted, watchEffect, getCurrentInstance } from 'vue'
import { Fold, Expand } from '@element-plus/icons-vue'
import userbar from './userbar.vue'
import { useRoute } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { getApplicationType } from '@/api/basicInformation'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
  // 是否收缩菜单
  isFold: { type: Boolean, default: false }
  // 是否为KEBS账号
  // isKEBS: { type: Boolean, default: false }
},
  emits: ['isFoldChange'],
  setup(__props, { emit }) {

const props = __props

const store = useMainStore()
const route = useRoute()

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const { proxy } = getCurrentInstance() as any
const lang = localStorage.getItem('LANG') || proxy.$config.LANG
const isShowAllType = ref(true)
const isShowType = ref(false)

// 菜单收缩
const onShrinkMenu = () => {
  emit('isFoldChange', !props.isFold)
}

const pageTitle = ref<string>('')
// 当前是否为微应用
const isQiankun = ref(false)

// 选择业务
// const businessType = ref<any>(0)

// 切换业务
// const onChangeBusiness = (val: number) => {
//   localStorage.setItem('APPLY_TYPE', val)
//   location.reload()
// }
const applyTypeList = ref<any>([])
const allApplyType = {
  applicationBriefName: t('parameterManagement.allType'), // 全部类型
  applicationBriefNameEn: t('parameterManagement.allType'), // 全部类型
  id: 0,
  applyTypeCode: '',
  countryId: ''
}

// 获取申请类型信息
const getApplyTypeData = () => {
  getApplicationType().then((res: any) => {
    if (res.code === 100200) {
      if (res.result && res.result.length) {
        applyTypeList.value = res.result[0] && res.result[0].children ? res.result[0].children : []
        applyTypeList.value.unshift(allApplyType)
        for (let i = 0; i < applyTypeList.value.length; i++) {
          const element = applyTypeList.value[i]
          applyTypeList.value[i].value = element.id
          applyTypeList.value[i].label = lang === 'en' && element.applicationBriefNameEn ? element.applicationBriefNameEn : element.applicationBriefName
          applyTypeList.value[i].applicationBriefName = lang === 'en' && element.applicationBriefNameEn ? element.applicationBriefNameEn : element.applicationBriefName
          if (applyTypeList.value[i].children) {
            for (let j = 0; j < applyTypeList.value[i].itemList.length; j++) {
              applyTypeList.value[i].itemList[j].value = applyTypeList.value[i].itemList[j].id
              applyTypeList.value[i].itemList[j].label = applyTypeList.value[i].itemList[j].name
            }
          }
        }
      }
    } else {
      ElMessage.error(res.msg)
    }
  })
}
onMounted(() => {
  // businessType.value = localStorage.getItem('APPLY_TYPE') ? Number(localStorage.getItem('APPLY_TYPE')) : 0
  pageTitle.value = lang === 'en' ? route.meta.titleEn as string : route.meta.title as string
  if ((window as any).__POWERED_BY_QIANKUN__) {
    isQiankun.value = true
  }
  getApplyTypeData()
})
watchEffect(() => {
  // 当前菜单
  if (route.meta && route.meta.title) {
    pageTitle.value = lang === 'en' ? route.meta.titleEn as string : route.meta.title as string
    store.updateCurrentMenu(route.meta)
  }
  // 判断是否展示切换类型
  const pageList = store.PermissionMenuList[0].children
  const checkPathExists = (paths: any, targetPath: any) => {
    if (targetPath.includes('contractReport') || targetPath.endsWith('uploadData')) {
      return true
    }
    if (targetPath.includes('KenyaOfficial') || targetPath.includes('KebsQueries') || targetPath.includes('port')) {
      return false
    }
    for (const item of paths) {
      // 检查当前对象的path
      if (item.routePath === targetPath || targetPath === '/') {
        return true
      }
      // 检查当前对象的子对象（如果有的话）
      if (item.children && item.children.length > 0) {
        for (const child of item.children) {
          if (child.routePath === targetPath) {
            return true
          }
        }
      }
    }
    return false
  }
  // isShowAllType.value = checkPathExists(pageList, route.path)
  // // 判断是否为KEBS角色，否则隐藏类型选择
  // if (store.rolesList && store.rolesList.length) {
  //   isShowType.value = store.rolesList.indexOf('KEBS') === -1
  //   if (store.rolesList.indexOf('KEBS') !== -1) {
  //     for (let j = 0; j < applyTypeList.value.length; j++) {
  //       const element = applyTypeList.value[j]
  //       if (element.applyTypeCode === 'export_product_certificate.pvoc_kenya') {
  //         localStorage.setItem('APPLY_TYPE', element.id)
  //         businessType.value = element.id
  //         break
  //       }
  //     }
  //   }
  // } else {
  //   isShowType.value = true
  // }
})
// 跳转工作台
const pushPage = () => {
  if (isQiankun.value) {
    window.location.href = window.location.origin
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!__props.isFold)
          ? (_openBlock(), _createBlock(_unref(Fold), {
              key: 0,
              style: {"color":"#000000","width":"22px","height":"22px","cursor":"pointer"},
              onClick: onShrinkMenu
            }))
          : _createCommentVNode("", true),
        (__props.isFold)
          ? (_openBlock(), _createBlock(_unref(Expand), {
              key: 1,
              style: {"color":"#000000","width":"22px","height":"22px","cursor":"pointer"},
              onClick: onShrinkMenu
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageTitle.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(userbar)
      ])
    ])
  ]))
}
}

})